/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-curly-newline */
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import Dialog from '~/components/dialog';
import useApi, { ApiMethod } from '~/hooks/useApi';
import endpoints from '~/services/endpoints';
import {
  PAYMENT_METHODS,
  TIPO_TRANSACAO,
  TipoTransacao,
} from '~/utils/payment-methods';
import Select, { IOption } from '~/components/select';
import Loading from '~/components/loading';
import { icons } from '~/assets';
import {
  currencyUnmasked,
  creditCardMask,
  currencyMask,
  IDefaultReturn,
  cpfMask,
} from '~/utils/masks';

import { creditCardValidation } from '~/utils/validators';

import * as St from './styles';
import Container from '~/components/container';
import Constants from '~/utils/constants';
import AutoCompleteSelect from '~/components/AutoCompleteSelect';

const CATEGORIA_PADRAO = 'PADRAO';
const CATEGORIAS_ESPECIAIS = new Set(['PLATINUM', 'CONVENIO']);

const getCategoriaCartao = (tema?: string): string => {
  const temaEmMaiusculas = tema?.toUpperCase();
  if (temaEmMaiusculas && CATEGORIAS_ESPECIAIS.has(temaEmMaiusculas)) {
    return temaEmMaiusculas;
  }
  return CATEGORIA_PADRAO;
};

interface IForm {
  nome?: string;
  cpf?: string;
  paymentMethod?: string;
  listCompany?: any[];
  loja?: {
    estabelecimento?: string;
    nome?: string;
  };
  numeroCartao?: string;
  valor?: string;
  valorParcela?: string;
  valorTotal?: string;
  tipoTransacao?: string;
  descricao?: null | string;
  cartoes?: {
    tipoCartao?: string;
    numeroCartao?: string;
    temaDoCartao?: string;
  }[];
}

const PurchaseInclusion = () => {
  const [form, setForm] = useState<IForm>({
    nome: '',
    cpf: '',
    numeroCartao: '',
    paymentMethod: null,
    listCompany: [],
    loja: {
      estabelecimento: '',
      nome: '',
    },
    valor: '0,00',
    tipoTransacao: '',
    descricao: null,
  });

  console.log('FORM.VALUR', form.valor);
  const [popUpMessage, setPopUpMessage] = useState('');
  const [popUpErrorMessage, setPopUpErrorMessage] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [popUpError, setPopUpError] = useState(false);
  const [dialogApproveMessageOpen, setApproveDialogMessageOpen] = useState(
    false,
  );
  const [popUpLoginModal, setPopUpLoginModal] = useState(false);
  const [cpf, setCpf] = useState<IDefaultReturn>({} as IDefaultReturn);
  const [senha, setSenha] = useState('');
  const user = JSON.parse(localStorage.getItem(Constants.USER));

  const history = useHistory();
  const location = useLocation<IForm>();

  const cardOptions: IOption[] = (location.state?.cartoes ?? []).map(
    (cartao) => ({
      id: cartao.numeroCartao,
      value: `${cartao.tipoCartao} - ${creditCardMask(cartao.numeroCartao).masked}`,
    }),
  );

  const cartaoSelecionado = location.state?.cartoes?.find(
    (cartao) => cartao.numeroCartao === form.numeroCartao,
  );

  const fetchPaymentRules = async (
    tipoTransacao = form.tipoTransacao,
    cartao = cartaoSelecionado,
  ) => {
    if (tipoTransacao !== TipoTransacao.CARTAO_DE_CREDITO) return;

    await GetPaymentRules.callApi({
      bandeira: 'TEUCARD',
      valorTotal: currencyUnmasked(form.valor),
      categoria: getCategoriaCartao(cartao?.temaDoCartao),
    });
  };

  const RequestSetTransaction = useApi<any[]>(
    `${endpoints.register.postSetTransaction}`,
    ApiMethod.POST,
  );

  const RequestGetBusiness = useApi<any[]>(
    `${endpoints.consult.searchCompanyByAutorizador}`,
    ApiMethod.GET,
  );
  const GetPaymentRules = useApi<any[]>(
    `${endpoints.consult.getPaymentRules}`,
    ApiMethod.GET,
    {},
    true,
  );

  const AuthValidatePassword = useApi<any>(
    endpoints.account.validateUserPassword,
    ApiMethod.POST,
  );

  useEffect(() => {
    const getBusiness = async () => {
      const response = await RequestGetBusiness.callApi();
      if (response.status >= 200 && response.status < 300) {
        setForm({
          ...form,
          listCompany: response.data.map((item: any) => ({
            value: item.nome,
            estabelecimento: item.estabelecimento,
          })),
          numeroCartao: location.state?.cartoes?.[0]?.numeroCartao,
          nome: location.state?.nome,
          cpf: location.state?.cpf,
        });
      }
    };
    getBusiness();
  }, []);

  const handleValidation = () => {
    let isValid = true;

    if (form.tipoTransacao === TipoTransacao.CARTAO_DE_CREDITO) {
      if (!creditCardValidation(form.numeroCartao)) {
        setPopUpErrorMessage('Cartão de crédito inválido');
        setPopUpError(true);
        isValid = false;
      }
    }

    if (!form.valor || Number(form.valor.replace(',', '.')) <= 0) {
      setPopUpErrorMessage('O valor da transação deve ser maior do que zero');
      setPopUpError(true);
      isValid = false;
    }

    if (
      form.tipoTransacao === TipoTransacao.CARTAO_DE_CREDITO &&
      !form.paymentMethod
    ) {
      setPopUpErrorMessage('Selecione a quantidade de parcelas');
      setPopUpError(true);
      isValid = false;
    }

    if (!form.loja?.estabelecimento) {
      setPopUpErrorMessage('Selecione um caixa');
      setPopUpError(true);
      isValid = false;
    }

    return isValid;
  };

  const handlePasswordValidate = async () => {
    try {
      const { status, mensagem } = await AuthValidatePassword.callApi({
        cpf: cpf.unmasked,
        senha,
      });
      if (status >= 200 && status <= 300) {
        handleClick();
        setPopUpLoginModal(false);
      } else {
        setPopUpLoginModal(false);
        setPopUpErrorMessage(mensagem);
        setPopUpError(true);
      }
    } catch (err) {
      setPopUpMessage(err.mensagem);
      console.log(err);
    }
  };

  const handleClick = async () => {
    const valorMask = currencyMask(form.valor);

    const payload = {
      cliente: {
        nome: form.nome,
        cpf: form.cpf,
      },
      descricao: form.descricao,
      loja: {
        estabelecimento: parseInt(form.loja?.estabelecimento || 0),
        nome: form.loja.nome,
      },
      numeroCartao: form.numeroCartao,
      parcelas: form.paymentMethod,
      tipoTransacao: form.tipoTransacao,
      usuarioSolicitacao: {
        id: user.id,
        nome: user.nomeTitular,
      },
      valor: currencyUnmasked(valorMask),
    };
    if (form.tipoTransacao === TipoTransacao.CARTAO_DE_CREDITO) {
      payload.valorParcela = currencyUnmasked(form.valorParcela);
      payload.valorTotal = currencyUnmasked(form.valorTotal);
    }
    const response = await RequestSetTransaction.callApi(payload);

    setPopUpMessage(response.mensagem);
    setOpenDialog(true);
  };
  return (
    <>
      <Loading
        status={
          RequestSetTransaction.loading ||
          AuthValidatePassword.loading ||
          GetPaymentRules.loading
        }
      />
      <Dialog
        icon={icons.confirmation}
        open={dialogApproveMessageOpen}
        positiveLabel="Sim"
        negativeLabel="Não"
        negativeAction={() => {
          setApproveDialogMessageOpen(false);
          history.push('/homeDash');
        }}
        positiveAction={() => setPopUpLoginModal(true)}
        message="Você já realizou e confirmou o estorno desta transação?"
      />
      <Dialog
        open={openDialog}
        message={popUpMessage}
        positiveAction={() => {
          setOpenDialog(false);
          history.push('/homeDash');
        }}
        positiveLabel="Entendi"
        icon={icons.check}
      />
      <Dialog
        open={popUpError}
        message={popUpErrorMessage}
        positiveAction={() => {
          setPopUpError(false);
          setApproveDialogMessageOpen(false);
        }}
        positiveLabel="Entendi"
        icon={icons.check}
      />
      <Dialog
        open={popUpLoginModal}
        positiveLabel="Sim"
        negativeLabel="Não"
        negativeAction={() => {
          setApproveDialogMessageOpen(false);
          history.push('/homeDash');
        }}
        positiveAction={handlePasswordValidate}
        message="Insira sua senha"
        buttonDisabledPositive={
          RequestSetTransaction.loading || AuthValidatePassword.loading
        }
      >
        <Input
          name="cpf"
          id="cpf"
          type="text"
          label="CPF"
          maxLength={14}
          value={cpf.masked}
          onChange={(e) => setCpf(cpfMask(e.target.value))}
        />
        <Input
          name="senha"
          id="senha"
          type="password"
          label="Senha"
          maxLength={6}
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
      </Dialog>

      <Container>
        <St.BoxCard>
          <ContainerFlex row space>
            <ContainerFlex padding={16}>
              <Select
                label="Escolha como será realizada a transação"
                value={form.tipoTransacao}
                options={TIPO_TRANSACAO}
                onChange={(e) => {
                  setForm({ ...form, tipoTransacao: e });
                  fetchPaymentRules(e);
                }}
              />
            </ContainerFlex>

            <ContainerFlex padding={16}>
              <Input
                label="Valor"
                placeholder="0,00"
                name="valor"
                onBlur={() => fetchPaymentRules()}
                mask={MaskTypes.CURRENCY}
                value={form.valor}
                onChange={(e) => {
                  const v = e.target.value;
                  if (!v) {
                    setForm({ ...form, valor: '0,00' });
                    return;
                  }
                  console.log(v);
                  if (GetPaymentRules.data) {
                    setForm({
                      ...form,
                      valor: e.target.value,
                      paymentMethod: '',
                      valorParcela: '',
                      valorTotal: '',
                    });
                  } else {
                    setForm({ ...form, valor: e.target.value });
                  }
                }}
              />
            </ContainerFlex>

            {form.tipoTransacao === TipoTransacao.CARTAO_DE_CREDITO && (
              <ContainerFlex padding={16}>
                <Select
                  label="Parcela"
                  value={form.paymentMethod}
                  options={
                    GetPaymentRules?.data?.length > 0
                      ? GetPaymentRules?.data?.map((e) => {
                          if (e.parcela === 1)
                            return { id: e.parcela, value: 'À Vista' };
                          return {
                            id: e.parcela,
                            value: `${e.parcela}x`,
                          };
                        })
                      : []
                  }
                  onChange={(e) => {
                    const found = GetPaymentRules.data.find(
                      (i) => i.parcela === e,
                    );
                    setForm({
                      ...form,
                      paymentMethod: e,
                      valorParcela: currencyMask(found.valorParcela),
                      valorTotal: currencyMask(found.valorTotal),
                    });
                  }}
                />
              </ContainerFlex>
            )}
          </ContainerFlex>

          <ContainerFlex row space>
            <ContainerFlex padding={16} flex={2}>
              <Select
                label="Número do cartão"
                value={form.numeroCartao}
                options={cardOptions}
                onChange={(e) => {
                  setForm({
                    ...form,
                    numeroCartao: e,
                    paymentMethod: '',
                    valorParcela: '',
                    valorTotal: '',
                  });

                  const novoCartaoSelecionado = location.state?.cartoes?.find(
                    (cartao) => cartao.numeroCartao === e,
                  );

                  fetchPaymentRules(form.tipoTransacao, novoCartaoSelecionado);
                }}
              />
            </ContainerFlex>

            <ContainerFlex padding={16}>
              <AutoCompleteSelect
                label="Loja"
                value={form.loja.estabelecimento}
                options={form.listCompany}
                onChange={(e) =>
                  setForm({
                    ...form,
                    loja: { estabelecimento: e.estabelecimento, nome: e.value },
                  })
                }
              />
            </ContainerFlex>
            {form.tipoTransacao === TipoTransacao.CARTAO_DE_CREDITO && (
              <>
                <ContainerFlex padding={16} flex={0.5}>
                  <Input
                    label="Valor Parcela"
                    placeholder="0,00"
                    name="valorParcela"
                    mask={MaskTypes.CURRENCY}
                    value={form.valorParcela}
                  />
                </ContainerFlex>
                <ContainerFlex padding={16} flex={0.5}>
                  <Input
                    label="Valor Total"
                    placeholder="0,00"
                    name="valorTotal"
                    mask={MaskTypes.CURRENCY}
                    value={form.valorTotal}
                  />
                </ContainerFlex>
              </>
            )}

            <ContainerFlex padding={16}>
              <Button
                fitContent
                disabled={RequestSetTransaction.loading}
                onClick={() => {
                  if (handleValidation()) {
                    handleClick();
                  }
                }}
              >
                Solicitar Transação
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>
      </Container>
    </>
  );
};

export default PurchaseInclusion;
